import Parse from "parse";

import { useParseQueryFirstCached } from "@opendash/plugin-parse";
import { Skeleton, Tag } from "antd";
import React from "react";
import { Order } from "../../types";
type ActiveOrderColumnProps = React.PropsWithChildren & {
  orderPlanNr: string;
  render: (order: Order) => React.ReactNode;
};

const ActiveOrderFieldColumn = ({
  orderPlanNr,
  render,
}: ActiveOrderColumnProps) => {
  const orderQ = React.useMemo(() => {
    const orderQ = new Parse.Query(Order);
    orderQ.equalTo("ordernr", orderPlanNr);
    orderQ.descending("start");
    return orderQ;
  }, [orderPlanNr]);

  const {
    result: currentOrder,
    loading,
    reload,
    error,
  } = useParseQueryFirstCached<Order>(
    orderQ,
    `mes-currentOrder-${orderPlanNr}`,
    5000
  );
  const content = render(currentOrder);
  console.log({ currentOrder, error, loading });
  return (
    <>
      {!loading && !error && content}
      {loading && <Skeleton.Input active={true} size={"small"} />}
      {!loading && error && <Tag color="red">!</Tag>}
    </>
  );
};

export { ActiveOrderColumnProps, ActiveOrderFieldColumn };
